require('./src/styles/global.css');

// Load Prism core before any language components
require('prismjs');

// Languages used in article code blocks
require('prismjs/components/prism-json');
require('prismjs/components/prism-kotlin');
require('prismjs/components/prism-java');
require('prismjs/components/prism-scala');
require('prismjs/components/prism-python');
require('prismjs/components/prism-ruby');
require('prismjs/components/prism-bash');
require('prismjs/components/prism-sql');
require('prismjs/components/prism-yaml');
require('prismjs/components/prism-groovy');
require('prismjs/components/prism-swift');
require('prismjs/components/prism-c');       // required by objectivec
require('prismjs/components/prism-objectivec');
require('prismjs/components/prism-typescript');
require('prismjs/components/prism-nginx');
require('prismjs/components/prism-go');

const React = require('react');
const ReactDOM = require('react-dom');
const AacDemo = require('./src/components/AacDemo').default;
const ListeningTest = require('./src/components/ListeningTest').default;

let activeContainers = [];

exports.onRouteUpdate = () => {
  activeContainers.forEach(container => {
    ReactDOM.unmountComponentAtNode(container);
  });
  activeContainers = [];

  const demo = document.getElementById('aac-demo');
  if (demo) {
    ReactDOM.render(React.createElement(AacDemo), demo);
    activeContainers.push(demo);
  }
  const test = document.getElementById('listening-test');
  if (test) {
    ReactDOM.render(React.createElement(ListeningTest), test);
    activeContainers.push(test);
  }
};
